/* Babokah Tarzı — tema betiği (bağımlılıksız) */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var routes = (window.theme && window.theme.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  var root = routes.root.replace(/\/$/, '');

  /* ---------- Para formatı ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount}} TL';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  /* ---------- Bildirim ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Çekmeceler ---------- */
  var overlay = $('[data-overlay]');
  /* Mobil menü sticky header'ın katmanında kalmasın diye body'ye taşınır */
  function hoistMenu(scope) {
    var md = $('[data-menu-drawer]', scope);
    if (!md || md.parentElement === document.body) return;
    $$('body > [data-menu-drawer]').forEach(function (old) { if (old !== md) old.remove(); });
    document.body.appendChild(md);
  }
  hoistMenu(document);
  function openDrawer(el) {
    if (!el) return;
    closeDrawers();
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawers() {
    $$('.mobile-drawer.is-open, .cart-drawer.is-open, .filters.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-menu]')) { e.preventDefault(); openDrawer($('[data-menu-drawer]')); }
    else if (t.closest('[data-close-drawers]') || t === overlay) { e.preventDefault(); closeDrawers(); }
    else if (t.closest('[data-open-filters]')) { e.preventDefault(); openDrawer($('[data-filters-form]')); }
    else if (t.closest('[data-open-cart]') && window.theme && window.theme.cartType === 'drawer' && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); openDrawer($('[data-cart-drawer]'));
    }
    else if (t.closest('[data-open-search]')) {
      e.preventDefault();
      var p = $('[data-search-panel]');
      if (p) { p.classList.toggle('is-open'); if (p.classList.contains('is-open')) { var i = $('input[type="search"]', p); if (i) i.focus(); } }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); var p = $('[data-search-panel]'); if (p) p.classList.remove('is-open'); }
  });

  /* ---------- Duyuru çubuğu ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0, speed = parseInt(bar.dataset.speed, 10) || 4000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Hero slider ---------- */
  function initHeroes(scope) { $$('[data-hero]', scope).forEach(function (hero) {
    if (hero.dataset.ready) return; hero.dataset.ready = '1';
    var track = $('[data-hero-track]', hero);
    var slides = track ? track.children : [];
    var dots = $$('[data-hero-dot]', hero);
    var n = slides.length; if (n < 2) return;
    var i = 0, timer = null;
    var speed = parseInt(hero.dataset.speed, 10) || 5000;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function play() { if (hero.dataset.autoplay === 'true') { stop(); timer = setInterval(function () { go(i + 1); }, speed); } }
    function stop() { if (timer) clearInterval(timer); }
    var prev = $('[data-hero-prev]', hero), next = $('[data-hero-next]', hero);
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.heroDot, 10)); play(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; play();
    });
    play();
  }); }
  initHeroes(document);

  /* ---------- Ürün carousel ---------- */
  function initCarousels(scope) {
    $$('[data-carousel]', scope).forEach(function (c) {
      if (c.dataset.ready) return; c.dataset.ready = '1';
      var track = $('[data-carousel-track]', c);
      var prev = $('[data-carousel-prev]', c), next = $('[data-carousel-next]', c);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var img = $('.card__media', track);
        if (img) c.style.setProperty('--arrow-top', (img.offsetHeight / 2 - 17) + 'px');
      }
      function step(dir) {
        var card = track.firstElementChild; if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var per = Math.max(1, Math.round(track.clientWidth / (card.offsetWidth + gap)));
        track.scrollBy({ left: dir * per * (card.offsetWidth + gap), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  }
  initCarousels(document);

  /* ---------- Sepet ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }
  function refreshCartDrawer(open) {
    return fetch(root + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        var wrap = document.getElementById('shopify-section-cart-drawer');
        if (html && wrap) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer]');
          var old = $('[data-cart-drawer]', wrap);
          if (fresh && old) { old.innerHTML = fresh.innerHTML; }
        }
        return fetch(routes.cart + '.js', { credentials: 'same-origin' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (open) openDrawer($('[data-cart-drawer]'));
        return cart;
      });
  }
  function addToCart(formData) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) { throw new Error(json.description || json.message || 'Ürün sepete eklenemedi.'); }
        return json;
      });
    });
  }
  function afterAdd() {
    if (window.theme && window.theme.cartType === 'page') { window.location.href = routes.cart; return; }
    refreshCartDrawer(true).catch(function () { window.location.href = routes.cart; });
  }
  function changeLine(line, qty) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0) })
    }).then(function (r) { return r.json(); }).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshCartDrawer(false);
    });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      var fd = new FormData(); fd.append('id', q.dataset.quickAdd); fd.append('quantity', 1);
      var label = q.textContent; q.disabled = true; q.textContent = 'EKLENİYOR...';
      addToCart(fd).then(afterAdd).catch(function (err) { toast(err.message); })
        .finally(function () { q.disabled = false; q.textContent = label; });
      return;
    }
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var rem = e.target.closest('[data-remove-line]');
    if (minus || plus) {
      var ln = (minus || plus).dataset[minus ? 'qtyMinus' : 'qtyPlus'];
      var inp = $('[data-qty-input="' + ln + '"]', (minus || plus).closest('.cart-line'));
      var v = (parseInt(inp.value, 10) || 0) + (minus ? -1 : 1);
      inp.value = Math.max(0, v); changeLine(ln, inp.value);
    } else if (rem) {
      changeLine(rem.dataset.removeLine, 0);
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qty-input]');
    if (inp) changeLine(inp.dataset.qtyInput, inp.value);
  });

  /* ---------- Ürün sayfası ---------- */
  $$('[data-product]').forEach(function (wrap) {
    var jsonEl = $('[data-product-json]', wrap);
    var data = {};
    try { data = JSON.parse(jsonEl ? jsonEl.textContent : '{}'); } catch (err) { data = {}; }
    var variants = data.variants || [];
    var form = $('[data-product-form]', wrap);
    var idInput = $('[data-variant-id]', wrap);
    var addBtn = $('[data-add-btn]', wrap);
    var buyBtn = $('[data-buy-now]', wrap);
    var priceBox = $('[data-price-box]', wrap);
    var sku = $('[data-sku]', wrap);
    var msg = $('[data-form-msg]', wrap);
    var groups = $$('[data-option-index]', wrap);

    /* Galeri */
    var slides = $$('[data-slide]', wrap), thumbs = $$('[data-thumb]', wrap), gi = 0;
    function show(k) {
      if (!slides.length) return;
      gi = (k + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === gi); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === gi); });
      if (thumbs[gi] && thumbs[gi].scrollIntoView && window.innerWidth > 989) {
        var box = thumbs[gi].parentElement;
        box.scrollTo({ top: thumbs[gi].offsetTop - box.offsetTop - 40, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.thumb, 10)); }); });
    var gp = $('[data-gallery-prev]', wrap), gn = $('[data-gallery-next]', wrap);
    if (gp) gp.addEventListener('click', function () { show(gi - 1); });
    if (gn) gn.addEventListener('click', function () { show(gi + 1); });
    var main = $('.gallery__main', wrap), tx = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (tx === null) return; var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) show(dx < 0 ? gi + 1 : gi - 1); tx = null;
      });
    }

    /* Varyant seçimi */
    function selected() {
      return groups.map(function (g) {
        var a = $('.is-active', g); return a ? a.dataset.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }
    function markAvailability() {
      var sel = selected();
      groups.forEach(function (g, gi2) {
        $$('[data-value]', g).forEach(function (b) {
          var test = sel.slice(); test[gi2] = b.dataset.value;
          var match = variants.find(function (v) {
            return test.every(function (o, i) { return o === null || v.options[i] === o; }) && v.available;
          });
          b.classList.toggle('is-unavailable', !match);
        });
      });
    }
    function renderPrice(v) {
      if (!priceBox) return;
      var f = data.moneyFormat;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        priceBox.innerHTML = '<span class="discount-badge">%' + pct + '</span><span class="price-stack"><span class="price-old">' +
          formatMoney(v.compare_at_price, f) + '</span><span class="price-now">' + formatMoney(v.price, f) + '</span></span>';
      } else {
        priceBox.innerHTML = '<span class="price-now">' + formatMoney(v.price, f) + '</span>';
      }
    }
    function onChange() {
      var v = findVariant(selected());
      if (msg) msg.classList.remove('is-visible');
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'MEVCUT DEĞİL'; }
        if (buyBtn) buyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      renderPrice(v);
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'SEPETE EKLE' : 'TÜKENDİ'; }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (sku) { sku.hidden = !v.sku; var s = $('span', sku); if (s) s.textContent = v.sku || ''; }
      if (v.featured_media) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId == v.featured_media.id; });
        if (idx > -1) show(idx);
      }
      groups.forEach(function (g) {
        var cur = $('[data-option-current]', g), a = $('.is-active', g);
        if (cur && a) cur.textContent = a.dataset.value;
      });
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      markAvailability();
    }
    groups.forEach(function (g) {
      $$('[data-value]', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-value]', g).forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active'); onChange();
        });
      });
    });
    if (groups.length) markAvailability();

    function showError(text) { if (msg) { msg.textContent = text; msg.classList.add('is-visible'); } else { toast(text); } }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.dataset.label = addBtn.textContent; addBtn.textContent = 'EKLENİYOR...'; }
        addToCart(new FormData(form)).then(afterAdd).catch(function (err) { showError(err.message); })
          .finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.dataset.label || 'SEPETE EKLE'; } });
      });
    }
    if (buyBtn && form) {
      buyBtn.addEventListener('click', function () {
        buyBtn.disabled = true;
        addToCart(new FormData(form)).then(function () { window.location.href = root + '/checkout'; })
          .catch(function (err) { showError(err.message); buyBtn.disabled = false; });
      });
    }
    var copy = $('[data-copy-link]', wrap);
    if (copy) copy.addEventListener('click', function (e) {
      e.preventDefault();
      if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).then(function () { toast('Bağlantı kopyalandı'); });
    });
    var wish = $('[data-wish]', wrap);
    if (wish) wish.addEventListener('click', function () {
      wish.classList.toggle('is-active');
      var svg = $('svg', wish); if (svg) svg.style.fill = wish.classList.contains('is-active') ? 'currentColor' : 'none';
    });
  });

  /* ---------- Benzer ürünler ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    if (box.children.length) return;
    var url = box.dataset.url; if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; initCarousels(box); }
    }).catch(function () {});
  });

  /* ---------- Koleksiyon filtreleri ---------- */
  var ff = $('[data-filters-form]');
  if (ff) {
    var t;
    function submitFilters() {
      var fd = new FormData(ff); var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '' && k !== 'sort_by_mobile') params.append(k, v); });
      window.location.href = ff.getAttribute('action') + '?' + params.toString();
    }
    ff.addEventListener('change', function (e) {
      if (e.target.matches('[data-sort-select]')) { $('input[name="sort_by"]', ff).value = e.target.value; }
      clearTimeout(t); t = setTimeout(submitFilters, e.target.type === 'number' ? 700 : 50);
    });
    ff.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(); });
  }

  /* ---------- Footer mobil akordeon ---------- */
  if (window.matchMedia('(max-width: 989px)').matches) {
    $$('[data-footer-col]').forEach(function (d) { d.removeAttribute('open'); });
  } else {
    $$('[data-footer-col] summary').forEach(function (s) { s.addEventListener('click', function (e) { e.preventDefault(); }); });
  }

  /* ---------- Yukarı çık ---------- */
  var top = $('[data-to-top]');
  if (top) {
    window.addEventListener('scroll', function () { top.classList.toggle('is-visible', window.scrollY > 500); }, { passive: true });
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Giriş / şifre sıfırla ---------- */
  var showRec = $('[data-show-recover]'), hideRec = $('[data-hide-recover]');
  var loginBox = $('[data-login-box]'), recBox = $('[data-recover-box]');
  function toggleRec(on) { if (loginBox && recBox) { loginBox.hidden = on; recBox.hidden = !on; } }
  if (showRec) showRec.addEventListener('click', function (e) { e.preventDefault(); toggleRec(true); });
  if (hideRec) hideRec.addEventListener('click', function (e) { e.preventDefault(); toggleRec(false); });
  if (window.location.hash === '#recover' || (recBox && $('.success, .errors', recBox))) toggleRec(true);

  /* ---------- Adres ülke seçimi ---------- */
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });

  /* ---------- Tema editörü desteği ---------- */
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); initHeroes(e.target); hoistMenu(e.target); });
})();
